var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Notice } from "../../icons/index";
import { makeStyles } from "../../styles/index";
import { digestMessage } from "../../utils/digestMessage";
import { IconButton } from "../IconButton/IconButton";
import { NotificationDialog } from "./dialog/NotificationDialog";
import { Notification as NotificationModel, NotificationIdentifier } from "./models/Notification";
import { NotificationMenu } from "./NotificationMenu";
var useStyles = makeStyles(function (theme) { return ({
    button: {
        width: 48,
        height: 48,
        position: 'relative',
    },
    unreadCount: {
        position: 'absolute',
        top: 0,
        right: 0,
        fontSize: 12,
        width: 20,
        height: 20,
        borderRadius: '50%',
        color: theme.palette.common.white,
        backgroundColor: '#ff0000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}); });
/**
 * ハッシュ化したユーザーID から切り出す、先頭からの文字数。
 *
 * 衝突しなければどの文字数でも良い。
 */
export var HASHED_USER_ID_CLIP_LENGTH = 8;
/**
 * お知らせを表示するコンポーネント
 *
 * サービスサイトから使用する場合はschoolIdを指定し、
 * カスタマーサイトから使用する場合はcloudIdを指定する。
 */
export var Notification = function (_a) {
    var model = _a.model, onSaveNotificationAlreadyRead = _a.onSaveNotificationAlreadyRead, fiscalYearUpdateInfo = _a.fiscalYearUpdateInfo, userId = _a.userId, otherProps = __rest(_a, ["model", "onSaveNotificationAlreadyRead", "fiscalYearUpdateInfo", "userId"]);
    var classes = useStyles();
    var unreadCount = useMemo(function () { return model.notifications.filter(function (_a) {
        var alreadyRead = _a.alreadyRead;
        return !alreadyRead;
    }).length; }, [model]);
    var _b = useState(false), menuOpen = _b[0], setMenuOpen = _b[1];
    var _c = useState(), menuRef = _c[0], setMenuRef = _c[1];
    var _d = useState(new NotificationModel({ id: new NotificationIdentifier('') })), selected = _d[0], setSelected = _d[1];
    var _e = useState(false), dialogOpen = _e[0], setDialogOpen = _e[1];
    var _f = useState(''), hashedUserId = _f[0], setHashedUserId = _f[1];
    useEffect(function () {
        digestMessage((userId === null || userId === void 0 ? void 0 : userId.toString()) || '', HASHED_USER_ID_CLIP_LENGTH).then(function (result) {
            setHashedUserId(result);
        });
    }, [userId]);
    // 参照をセット
    var handleSetMenuRef = useCallback(function (ref) { return setMenuRef(ref); }, []);
    // アイコンをクリック
    var handleClickButton = useCallback(function () { return setMenuOpen(true); }, []);
    // メニューアイテムをクリック
    var handleClickMenu = useCallback(function (clicked) {
        // メニューを閉じる
        setMenuOpen(false);
        if (!clicked) {
            return;
        }
        // ダイアログを開く
        setSelected(clicked);
        setDialogOpen(true);
        // 既読状態を保存
        onSaveNotificationAlreadyRead(clicked.id, true);
    }, [onSaveNotificationAlreadyRead]);
    // メニューを閉じる
    var handleCloseMenu = useCallback(function () { return setMenuOpen(false); }, []);
    // ダイアログを閉じる
    var handleCloseDialog = useCallback(function () { return setDialogOpen(false); }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.button, ref: handleSetMenuRef },
            React.createElement(IconButton, { onClick: handleClickButton },
                React.createElement(Notice, { width: 48, height: 48 })),
            unreadCount > 0 && React.createElement("div", { className: classes.unreadCount }, unreadCount)),
        React.createElement(NotificationMenu, { open: menuOpen, anchorRef: menuRef, notifications: model.notifications, onClick: handleClickMenu, onClose: handleCloseMenu }),
        React.createElement(NotificationDialog, { open: dialogOpen, notification: selected, notificationUrlParamsProps: __assign({ notificationId: selected.id, notificationOpenedAt: selected.openedAt, hashedUserId: hashedUserId }, otherProps), onOk: handleCloseDialog }),
        model.showFiscalYearUpdate && fiscalYearUpdateInfo));
};
